import type { ModifiedCampsiteMediaImageOrVideo, ModifiedUserMediaImageOrVideo, ModifiedCampsiteMediaImage, ModifiedUserCampsiteMediaImage, ModifiedCampsiteMediaVideo, ModifiedUserCampsiteMediaVideo, MediaImage, MediaVideo } from '@/types/media';

export function mediaIsImage(media: MediaImage | MediaVideo): media is MediaImage {
  return 'images' in media;
}

export function mediaIsVideo(media: MediaImage | MediaVideo): media is MediaVideo {
  return 'video_host' in media;
}

export function mediaIsModifiedImage(media: ModifiedCampsiteMediaImageOrVideo | ModifiedUserMediaImageOrVideo): media is ModifiedCampsiteMediaImage | ModifiedUserCampsiteMediaImage {
  return 'images' in media && 'idx' in media;
}

export function mediaIsModifiedVideo(media: ModifiedCampsiteMediaImageOrVideo | ModifiedUserMediaImageOrVideo): media is ModifiedCampsiteMediaVideo | ModifiedUserCampsiteMediaVideo {
  return 'video_host' in media && 'idx' in media;
}
